(function () {
    'use strict';

    var bodyElement = document.body;
    var siteHeaderElement = document.getElementById('dnn-site-header');
    var announcementBarElement = document.getElementById('announcement-bar');

    if (!siteHeaderElement || !announcementBarElement) {
        return;
    }

    var closeButtonElement = announcementBarElement.querySelector('.close');
    var isDnnUserLoggedIn = bodyElement.classList.contains('personabar-visible');
    var announcementVersion = announcementBarElement.getAttribute('data-announcement-version') || 'default';
    var localStorageKey = 'announcement-dismissed';

    if (!isDnnUserLoggedIn) {
        try {
            var dismissedVersion = localStorage.getItem(localStorageKey);

            if (dismissedVersion === announcementVersion) {
                announcementBarElement.classList.add('dismissed');
                siteHeaderElement.classList.add('ab-dismissed');
                return;
            }
        } catch (localStorageError) {}
    }

    announcementBarElement.classList.remove('d-none');

    if (!closeButtonElement) {
        return;
    }

    closeButtonElement.addEventListener('click', function () {
        announcementBarElement.classList.add('dismissed');
        siteHeaderElement.classList.add('ab-dismissed');

        if (isDnnUserLoggedIn) {
            return;
        }

        try {
            localStorage.setItem(localStorageKey, announcementVersion);
        } catch (localStorageError) {}
    });

}());